import { Directive, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  // https://www.telerik.com/kendo-angular-ui/components/inputs/debounce-valuechange/
  // Keeping as non-app selector to keep it as extension to regular Kendo module
  // tslint:disable-next-line: directive-selector
  selector: '[debounceValueChange]'
})
export class DebounceValueChangeDirective implements OnDestroy {
  /**
   * Emits the value change to the host kendo component with the delay specified as debounceDelay parameter (defaults = 500ms)
   */
  @Output() public debounceValueChange: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Delay that will be used to prevent multiple value changes in short succession. Value in ms. (defaults = 500ms)
   */
  @Input() public debounceDelay = 500;

  private readonly stream: Subject<any> = new Subject<any>();
  private readonly subscription: Subscription;

  constructor() {
    this.subscription = this.stream.pipe(debounceTime(this.debounceDelay)).subscribe((value: any) => this.debounceValueChange.next(value));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @HostListener('valueChange', ['$event'])
  public onValueChange(value: any): void {
    this.stream.next(value);
  }
}
